<div class="server-is-down-content">
    <div class="server-down-dialog-text">A client-server communications error has occurred</div>
    <div class="server-down-dialog-text">Take these steps to troubleshoot the problem:</div>
    <ul class="server-down-dialog-list">
        <li>Use ServerManager to check the OVOC / Apache server status</li>
        <li>Check the possibility of network connection issues</li>
        <li>Make sure your license is valid</li>
    </ul>
</div>
